import { FreshworksHelper } from "app/helpers/freshworksHelper";
import isPublicView from "app/utils/publicViewUtils";
import React, { lazy, Suspense, useEffect } from "react";
import { injectIntl } from "react-intl";
import { connect, useDispatch, useSelector } from "react-redux";
import type { UserType } from "../../types/userType";
import VerificationStatus from "./components/VerificationStatus/VerificationStatus";
const AccountMenu: React.LazyExoticComponent<any> = lazy(
  () => import("./screens/AccountMenu")
);
//
const AccountScreen = (props: { loadUser: Function; user: UserType }) => {
  const {
    verifiedStatus,
    lastLogin,
    lastLoginIpAddress: ipAddress,
  } = props.user;
  const user = useSelector(state => state.userModel.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch.userModel.loadUser();
    FreshworksHelper.showWidget();

    return () => {
      if (!isPublicView()) {
        FreshworksHelper.hideWidget();
      }
    };
  }, []);

  return (
    <Suspense fallback={<div className="fallback">loading...</div>}>
      <AccountMenu
        user={user}
        verifiedStatus={verifiedStatus}
        verifiedStatusFormatedText={
          <VerificationStatus verifiedStatus={verifiedStatus} />
        }
        lastLogin={lastLogin}
        ipAddress={ipAddress}
      />
    </Suspense>
  );
};

const mapStateToProps = state => ({
  user: state.userModel.user,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => {
    dispatch.userModel.loadUser();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AccountScreen));
